/**
 * Applies scroll offset styles on <html>.
 * Disabled briefly after newsletter submission to avoid autofocus scroll offset.
 * Must load synchronously in <head> (no defer/module).
 */
(function () {
	const SCROLL_BEHAVIOR = 'smooth';
	const SCROLL_PADDING_TOP_MOBILE = '300px';
	const SCROLL_PADDING_TOP_DESKTOP = '200px';
	const MOBILE_MEDIA_QUERY = '(max-width: 990px)';
	const RESTORE_DELAY_MS = 2000;
	const CUSTOMER_POSTED_PARAM = 'customer_posted';
	const NEWSLETTER_FORM_HASH = 'NewsletterForm';

	function isNewsletterPosted() {
		const searchParams = new URLSearchParams(window.location.search);

		return (
			searchParams.get(CUSTOMER_POSTED_PARAM) === 'true' &&
			window.location.hash.includes(NEWSLETTER_FORM_HASH)
		);
	}

	function getScrollPaddingTop() {
		return window.matchMedia(MOBILE_MEDIA_QUERY).matches
			? SCROLL_PADDING_TOP_MOBILE
			: SCROLL_PADDING_TOP_DESKTOP;
	}

	function applyScrollStyles() {
		document.documentElement.style.scrollBehavior = SCROLL_BEHAVIOR;
		document.documentElement.style.scrollPaddingTop = getScrollPaddingTop();
	}

	if (!isNewsletterPosted()) {
		applyScrollStyles();
		return;
	}

	window.setTimeout(applyScrollStyles, RESTORE_DELAY_MS);
})();
